import { Component, OnInit } from '@angular/core';
import { UserLogin } from '../../../Common/models/user.login';
import { ManageService } from '../../services/manage.service';
import { StatusService } from '../../../Common/services/status.service';
import { RoleKey, SalesPlanStatus } from '../../../Common/Constants/common.constants';
import { DatePipe } from '@angular/common';
import { RefTypeEnum } from '../../../project-intake/enums/ref-type-enum';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomEncodeDecodeService } from '../../../Common/services/custom-encode-decode.service';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';
import { ConfirmationService } from 'primeng/api';
import { ProjectService } from '../../../project-intake/services/project.service';
import { MessageService } from '../../../project-intake/services/message.service';

@Component({
  selector: 'retailhub-manage-salesplan',
  templateUrl: './retailhub-manage-salesplan.component.html',
  styleUrls: ['./retailhub-manage-salesplan.component.css', '../../../../assets/css/new-project.css'],
  providers: [DatePipe]
})

export class RetailHubManageSalesplanComponent implements OnInit {

  public selectedVendor: any;
  public categoryList: any[] = [];
  public userCategoryList: any[] = [];
  //public agencies? :any[] = [];
  public statuses?: any[] = [];
  public salesplanList?: any[] = [];
  selectedCategories: any[] = [];
  //selectedAgencies? :any[] = [];
  selectedStatus?: any[] = [];

  sortColumn: string = 'initiatedDate';
  sortDirection: 'asc' | 'desc' = 'desc';

  selectedSalesPlanIds: number[] = [];
  maxSelectable = 5;

  constructor(private manageService: ManageService<Blob>, private statusService: StatusService,
    private datepipe: DatePipe, private router: Router,
    private ngxService: NgxUiLoaderService,
    private encodeDecodeService: CustomEncodeDecodeService,
    private userRoleService: UserRoleServiceService,
    private projectService: ProjectService,
    private confirmationService: ConfirmationService,
    private msgService: MessageService) {
  }

  ngOnInit(): void {
    if (this.userRoleService.role?.roleKey == RoleKey.ITAdmin) {
      alert("Un authorized access");
      this.router.navigate(['/unauthorized']);
      return;
    }
    this.getUserRoleInfo();
    this.getStatusMaster();
  }

  getUserRoleInfo() {
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.selectedVendor = userRoleInfo.vendors[0];
      //userRoleInfo.categories =  userRoleInfo.categories?.filter(v=>v.vendorID == this.selectedVendor.vendorID);
      this.categoryList = userRoleInfo.categories;
      this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));
      this.userCategoryList = userRoleInfo.userCategory;
      if (this.userRoleService.role?.roleID == 4 || this.userRoleService.role?.roleID == 1) {
        this.selectedCategories = this.userCategoryList.map(a => a.categoryID);
      } else {
        this.selectedCategories = this.categoryList.map(a => a.value);
      }
    }
  }

  getStatusMaster() {
    this.ngxService.start();
    this.statusService.GetStatusMasterData().subscribe({
      next: (data: any) => {
        this.ngxService.stop();
        if (data) {
          this.statuses = data?.filter((d: any) => SalesPlanStatus.includes(d.statusName)).map((x: any) => ({ 'label': x.statusName, 'value': x.statusID }));
          this.selectedStatus = this.statuses?.map(a => a.value);
          this.getProjectData();
        }
      },
      error: (error) => {
        this.ngxService.stop();
        //this.toastr.error("Unexpected error occurred");
      }
    });
  }

  ExportSalesplanData() {
    let manageDto = {
      categories: this.selectedCategories,
      agencies: [],//this.selectedAgencies,
      status: this.selectedStatus,
      type: "SalesPlan"
    };

    this.manageService.ExportManageProjectSalesplanExcel(manageDto);
  }

  ExtractSalesplanData() {
    let manageDto = {
      categories: this.selectedCategories,
      agencies: [],//this.selectedAgencies,
      status: this.selectedStatus,
      type: "SalesPlan"
    };

    this.manageService.ExtractManageSalesplanExcel(manageDto);
  }

  getProjectData() {
    let manageDto = {
      categories: this.selectedCategories,
      agencies: [],//this.selectedAgencies,
      status: this.selectedStatus,
      type: "SalesPlan"
    };
    this.ngxService.start();
    this.manageService.GetManageProjectsData(manageDto).subscribe((data: any) => {
      this.ngxService.stop();
      if (data) {
        //Sort By Initiated Date Descending order
        data.sort((a: any, b: any) => {
          const dateA = a.initiatedDate ? new Date(a.initiatedDate).getTime() : 0;
          const dateB = b.initiatedDate ? new Date(b.initiatedDate).getTime() : 0;
          return dateB - dateA;
        });

        data.forEach((element: any) => {
          element.initiatedDate = element.initiatedDate && this.datepipe.transform(element.initiatedDate, 'dd-MMM-yyyy');
          element.startDate = element.startDate && this.datepipe.transform(element.startDate, 'dd-MMM-yyyy');
          element.endDate = element.endDate && this.datepipe.transform(element.endDate, 'dd-MMM-yyyy');
          element.projectStatuses = this.mergeStatusData(element.projectStatuses);
        });
       
        //data.sort((a: { refId: number; }, b: { refId: number; }) => b.refId - a.refId);

        this.salesplanList = data;
      }
    });
  }

  mergeStatusData(projectStatuses: any) {
    let mergedStatuses: any[] = [];
    this.statuses?.forEach((element: any) => {
      const matchedStatus = projectStatuses?.find((item: any) => (item.statusID == element.value));
      mergedStatuses.push({
        "projectStatusText": element.label,
        "statusID": element.value,
        "updatedBy": matchedStatus?.changedByName,
        "updatedDate": matchedStatus && this.datepipe.transform(matchedStatus?.changeDate, 'dd-MMM-yyyy')
      });
    });
    return mergedStatuses;
  }

  downloadStoresExcel(event: Event, refId: number, projectTitle: string): void {
    this.manageService.downloadStoresExcel(event, refId, RefTypeEnum.Sales, projectTitle);
  }

  navigateToEditSalesplan_bkp(salesplanId: number, catId: number) {
    //this.router.navigate(['/editsalesplan',salesplanId]); 
    this.router.navigate(['/editsalesplan', this.encodeDecodeService.encode(salesplanId), this.encodeDecodeService.encode(catId)]);
  }

  navigateToEditSalesplan(salesplanId: number, catId: number[]) {
    //this.router.navigate(['/editsalesplan',salesplanId]); 
    this.router.navigate(['/editsalesplan', this.encodeDecodeService.encode(salesplanId), this.encodeDecodeService.encode(catId)]);
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  sortSalesPlans(column: 'startDate' | 'endDate' | 'initiatedDate'): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.salesplanList?.sort((a, b) => {
      const dateA = a[column] ? new Date(a[column]) : new Date(0);
      const dateB = b[column] ? new Date(b[column]) : new Date(0);

      return this.sortDirection === 'asc'
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    });
  }

  onSalesPlanCheckboxChange(refId: number, event: any) {
    if (event.target.checked) {
      if (this.selectedSalesPlanIds.length < this.maxSelectable) {
        this.selectedSalesPlanIds.push(refId);
      } else {
        event.target.checked = false;
        this.msgService.htmlError(`You can select a maximum of ${this.maxSelectable} Sales Plans.`);
      }
    } else {
      this.selectedSalesPlanIds = this.selectedSalesPlanIds.filter(id => id !== refId);
    }
  }

  deleteSelectedSalesPlans() {
    if (this.selectedSalesPlanIds.length === 0) {
      this.msgService.htmlError("Please select at least one Sales Plan to delete.");
      return;
    }

    this.confirmationService.confirm({
      header: ' ',
      icon: 'pi pi-exclamation-triangle',
      message: "This action cannot be reversed. Are you sure to delete the SalesPlan(s)?",
      accept: () => {
        this.deleteProjects();
      },
      reject: () => {
        return;
      }
    })
  }

  deleteProjects() {
    this.projectService.deleteProjects(this.selectedSalesPlanIds, "SalesPlan").subscribe({
      next: async (data: any) => {
        if (data) {
          this.msgService.htmlSuccess("Sales Plan(s) deleted successfully");
          this.selectedSalesPlanIds = [];
          this.getProjectData();          
        }
      }
    })
  }
}
